import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

// Icons
import icChevronLeftGrey from '../assets/icons/icChevronLeftGrey.png';
import icChevronRightGrey from '../assets/icons/icChevronRightGrey.png';

const useStyles = makeStyles(theme => ({
    pageNumber: {
        width: theme.spacing(5),
        height: theme.spacing(5),
        borderRadius: '50%',
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        cursor: 'pointer',
        transition: '0.2s',

        '&:active': {
            opacity: 0.5
        }
    },
    selected: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
}))

function Index({ pages, currentPage, onChangePage, onPrevious, onNext }) {
    const classes = useStyles();

    if (pages.length === 0) return null;
    return (
        <Box pt={4} display="flex" flexDirection="row" justifyContent="center" alignItems="center">
            <IconButton onClick={onPrevious}>
                <img alt='' src={icChevronLeftGrey} style={{ width: 16, height: 16 }} />
            </IconButton>

            {
                pages.length <= 10 ? (
                    pages.map(page => <Typography
                        className={page === currentPage ? classnames(classes.pageNumber, classes.selected) : classes.pageNumber}
                        key={page}
                        onClick={() => onChangePage(page)}
                    >{page}</Typography>
                    )
                ) : (
                        <Fragment>
                            {
                                [1, 2, 3].map(page => (
                                    <Typography
                                        className={page === currentPage ? classnames(classes.pageNumber, classes.selected) : classes.pageNumber}
                                        key={page}
                                        onClick={() => onChangePage(page)}
                                    >{page}</Typography>
                                ))
                            }

                            {
                                currentPage === 3 && (
                                    <Fragment>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(4)}
                                        >4</Typography>
                                    </Fragment>
                                )
                            }

                            {
                                (currentPage === 4 && (
                                    <Fragment>
                                        <Typography
                                            className={classnames(classes.pageNumber, classes.selected)}
                                        >4</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(5)}
                                        >5</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                        >...</Typography>
                                    </Fragment>
                                ))
                            }

                            {
                                currentPage === 5 && (
                                    <Fragment>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(4)}
                                        >4</Typography>
                                        <Typography
                                            className={classnames(classes.pageNumber, classes.selected)}
                                        >5</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(6)}
                                        >6</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                        >...</Typography>
                                    </Fragment>
                                )
                            }

                            {
                                (currentPage > 5 && currentPage < pages.length - 4 && (
                                    <Fragment>
                                        <Typography
                                            className={classes.pageNumber}
                                        >...</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(currentPage - 1)}
                                        >{currentPage - 1}</Typography>
                                        <Typography
                                            className={classnames(classes.pageNumber, classes.selected)}
                                        >{currentPage}</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(currentPage + 1)}
                                        >{currentPage + 1}</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                        >...</Typography>
                                    </Fragment>
                                ))
                            }

                            {
                                (currentPage <= 3 || currentPage >= pages.length - 2) && (
                                    <Typography
                                        className={classes.pageNumber}
                                    >...</Typography>
                                )
                            }

                            {
                                currentPage === pages.length - 4 && (
                                    <Fragment>
                                        <Typography
                                            className={classes.pageNumber}
                                        >...</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(currentPage - 1)}
                                        >{currentPage - 1}</Typography>
                                        <Typography
                                            className={classnames(classes.pageNumber, classes.selected)}
                                        >{currentPage}</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(currentPage + 1)}
                                        >{currentPage + 1}</Typography>
                                    </Fragment>
                                )
                            }

                            {
                                currentPage === pages.length - 3 && (
                                    <Fragment>
                                        <Typography
                                            className={classes.pageNumber}
                                        >...</Typography>
                                        <Typography
                                            className={classes.pageNumber}
                                            onClick={() => onChangePage(currentPage - 1)}
                                        >{currentPage - 1}</Typography>
                                        <Typography
                                            className={classnames(classes.pageNumber, classes.selected)}
                                        >{currentPage}</Typography>
                                    </Fragment>
                                )
                            }

                            {
                                currentPage === pages.length - 2 && (
                                    <Typography
                                        className={classes.pageNumber}
                                        onClick={() => onChangePage(currentPage - 1)}
                                    >{currentPage - 1}</Typography>
                                )
                            }

                            {
                                [pages.length - 2, pages.length - 1, pages.length].map(page => (
                                    <Typography
                                        className={page === currentPage ? classnames(classes.pageNumber, classes.selected) : classes.pageNumber}
                                        key={page}
                                        onClick={() => onChangePage(page)}
                                    >{page}</Typography>
                                ))
                            }
                        </Fragment>
                    )
            }
            <IconButton onClick={onNext}>
                <img alt='' src={icChevronRightGrey} style={{ width: 16, height: 16 }} />
            </IconButton>
        </Box>
    );
}

Index.propTypes = {
    pages: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onPrevious: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
};

export default Index;
